import { render, staticRenderFns } from "./WawaIncentive.vue?vue&type=template&id=32db07b9&"
import script from "./WawaIncentive.vue?vue&type=script&lang=js&"
export * from "./WawaIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports